// SentryFallback — `Sentry.ErrorBoundary` の fallback UI (Phase 8 Task 8-6).
//
// React tree 内で unhandled error が発生したときに表示される. ErrorBoundary が
// catch した error は Sentry に自動送信され、ユーザにはこの画面が出る.
//
// ErrorScreen と並列の simple な構造にして、import 副作用を抑える (= ErrorBoundary
// fallback は最悪 Sentry SDK 自体が壊れていても render できる必要がある).

export const SentryFallback = (): React.ReactNode => {
  const reload = (): void => {
    if (typeof window !== 'undefined') {
      window.location.reload();
    }
  };

  return (
    // p-4 + w-full max-w: スマホ縦 (390/360px) はみ出し対策 (ErrorScreen と同パターン)。
    <div className="grid h-full place-items-center p-4" role="alert">
      <div className="w-full max-w-[420px] rounded border border-white/10 bg-[var(--color-panel)] p-6 shadow-xl">
        <h1 className="mb-3 text-center text-base font-bold text-[var(--color-error)]">
          エラーが発生しました
        </h1>
        <p className="mb-4 text-center text-xs text-[var(--color-text)]/85">
          画面の描画中に問題が発生しました。ページを再読み込みしてください。
          <br />
          問題が続く場合は時間を置いてから再度お試しください。
        </p>
        <button
          type="button"
          onClick={reload}
          className="w-full rounded bg-[var(--color-accent)] px-4 py-2 text-sm font-bold text-[var(--color-panel)] transition hover:brightness-110"
        >
          ページを再読み込み
        </button>
      </div>
    </div>
  );
};
